module.exports = __webpack_public_path__ + "static/media/Peru.8e9878cb.svg";